<template>
    <SettingsTabs tab-key="other-settings">
        <div class="mb-[98px] mt-[44px]">
            <div
                v-if="globalProps.team.personal_team && globalProps.user.app_type === null || globalProps.user.app_type == 'pro' || globalProps.user.app_type == 'both'"
                class="grid-cols-layout border-b border-gray-300 pb-5 lg:grid"
                @submit.prevent="updateNotificationPreferences"
            >
                <div class="mb-6 lg:mb-0 lg:mt-4">
                    <h3
                        class="mb-[5px] text-lg font-medium leading-normal tracking-small text-gray-800"
                    >
                        Email notifications
                    </h3>
                    <p class="max-w-xs text-sm text-gray-500">
                        Choose which emails you want to receive.
                    </p>
                </div>

                <form
                    class="mx-auto w-full rounded-md bg-white shadow-card lg:mx-0"
                >
                    <div
                        class="flex flex-wrap gap-6 border-b border-gray-200 px-6 pb-5 pt-[23px]"
                    >
                        <Toggle v-model="editorComments">
                            <span> New comments and mentions from Editor </span>
                        </Toggle>
                    </div>

                    <div class="flex justify-end">
                        <div class="my-3 pr-6">
                            <AtomicButton
                                type="submit"
                                color="yellow"
                                size="sm"
                                :disabled="loading"
                            >
                                Save changes
                            </AtomicButton>
                        </div>
                    </div>
                </form>
            </div>

            <SubscriptionInvoiceSettings
                :model-value="
                    globalProps.team.features?.recurring_invoice_emails ?? []
                "
                @update:modelValue="updateSubscriptionInvoiceSettings"
            />
        </div>
    </SettingsTabs>
</template>

<script lang="ts" setup>
import SettingsTabs from '../components/SettingsTabs.vue';

import { ITopolPageProps } from '@/types/TopolPageProps/TopolPageProps';
import { usePage } from '@inertiajs/vue3';

const globalProps = computed(() => usePage<ITopolPageProps>().props);

const features = ref(JSON.parse(globalProps.value.user.features ?? '{}'));
const notificationsEnabled = computed(() => {
    if (features.value.comments_notifications_disabled === null) {
        return true;
    } else if (features.value.comments_notifications_disabled === '1') {
        return false;
    } else return true;
});

const loading = ref(false);

const editorComments = ref(notificationsEnabled.value);

const updateNotificationPreferences = () => {
    router.put(
        route('settings.features.update'),
        {
            feature: 'comments_notifications_disabled',
            enable: !editorComments.value,
        },
        {
            onStart: () => {
                loading.value = true;
            },
            onFinish: () => {
                loading.value = false;
            },
            onSuccess: () => {
                create({
                    title: 'Notification preferences updated',
                    text: 'Your notification preferences have been updated.',
                    type: 'success',
                });
            },
            onError: () => {
                create({
                    title: 'Error',
                    text: 'An error occurred while updating your notification preferences.',
                    type: 'error',
                });
            },
        }
    );
};

const updateSubscriptionInvoiceSettings = (emails: string[]) => {
    router.put(
        route('settings.recurring-invoice-emails.update'),
        {
            emails: emails,
        },
        {
            preserveScroll: true,
            onSuccess: () => {
                create({
                    title: 'Emails updated',
                    type: 'success',
                });
            },
            onError: () => {
                create({
                    title: 'Emails not updated',
                    type: 'error',
                });
            },
        }
    );
};
</script>

<style></style>
